import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I’m <span className="purple">Vazgen Mkheyan</span> from{" "}
            <span className="purple">Hrazdan, Armenia</span>.
            <br />
            I’m a passionate <span className="purple">Software Developer</span>{" "}
            currently working at <span className="purple">Morpho</span>.
            <br />
            <br />
            I enjoy creating efficient, scalable, and user-friendly web
            applications that bring ideas to life. I’m always excited to learn
            new technologies and explore creative solutions to complex problems.
            <br />
            <br />
            Apart from coding, here are a few things I love doing:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Competitive Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling & Discovering Cultures 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)", marginTop: "15px" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Vazgen Mkheyan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
